import React from 'react'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  line: {
    margin: 'auto',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    width: '100%',
    height: 1,
    backgroundColor: theme.palette.grey.grey06,
  },
}))

const SeparatorLine: React.VFC = () => {
  const { classes } = useStyles()

  return <div className={classes.line} />
}

export default SeparatorLine
